import { Element } from 'slate';
import { getActiveEntities } from '../utils/entities';
import { EditorState } from '../Editor.types';
import { AulaEntity } from '../Entities';
import { hasFailedUpload } from './hasFailedUpload';
import { isInSelectionMode } from './hasUnselectedLtiContent';

/**
 * Computes whether an EditorState is allowed to be persisted
 * (which can be used for disabling "send" or "save" buttons https://github.com/AulaEducation/aula/issues/11002)
 */
export const isPersistable = (editorState: EditorState) =>
  editorState.value.length > 0 &&
  !editorState.value.some(
    (element) => Element.isElement(element) && element.failed
  ) &&
  !Object.values(getActiveEntities(editorState)).some(
    (aulaEntity: AulaEntity) =>
      aulaEntity.failed ||
      hasFailedUpload(aulaEntity) ||
      isInSelectionMode(aulaEntity)
  );
